import { useIsMobile } from 'hooks/useIsMobile';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

const LINK_CLASS = 'text-subtitle2 text-fg-secondary hover:text-link w-fit no-underline hover:underline';

const AuthFooter = (): JSX.Element => {
    const isMobile = useIsMobile();

    return (
        <div className="mx-auto w-full max-w-(--breakpoint-xl) px-4 sm:px-6">
            <div className={cn('flex', isMobile ? 'flex-col gap-2' : 'justify-end gap-6')}>
                <a href="https://crespect.com/" target="_blank" rel="noreferrer" className={LINK_CLASS}>
                    {t('footer.about-us')}
                </a>
                <a
                    href="https://crespect.com/home/privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                    className={LINK_CLASS}
                >
                    {t('footer.privacy-policy')}
                </a>
            </div>
        </div>
    );
};

export default AuthFooter;
